import React from 'react'
import { useSelector } from 'react-redux'
import LoadingSvg from '../../../components/atoms/Loading/Loading'
import ModalLogin from '../../../components/organisms/ModalLogin/ModalLogin'
import TailorMadeTemplate from '../../../components/template/TailorMadeTemplate/TailorMadeTemplate'
import { api } from '../../../utils'
import { PAGINEDETAIL } from '../../../utils/endpoint'

const TailorMadePage = ({ page }) => {
  const { utente, fetched } = useSelector((state) => state?.utente)
  if (fetched) {
    if (utente) {
      return <TailorMadeTemplate page={page} />
    } else {
      return <ModalLogin visible={true}></ModalLogin>
    }
  } else {
    return <LoadingSvg />
  }
}

export default TailorMadePage

export async function getServerSideProps({ params, locale }) {
  const pageResponse = await api.get(PAGINEDETAIL, {
    params: { chiave: 'tailor-made', lang: locale },
  })
  const page = await pageResponse.data

  const toolbarProps = { toolbarPage: page }
  return {
    props: { page, ...toolbarProps },
  }
}
